import script from "./assistant-card.vue?vue&type=script&setup=true&lang=js"
export * from "./assistant-card.vue?vue&type=script&setup=true&lang=js"

import "./assistant-card.vue?vue&type=style&index=0&id=493e1b0e&lang=scss&scoped=true"
import "./assistant-card.vue?vue&type=style&index=1&id=493e1b0e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-493e1b0e"]])

export default __exports__